<template>
    <div class="switchSuccess">
        <div class="content-top">
            <h1>{{$t('switch_plan.switch_free_title')}}</h1>
        </div>
        <div class="content-center">
            <div class="middle-package">
                <p class="package">{{$t('switch_plan.switch_free_detail')}}</p>
                <plan-message :list="message" class="plan-message" v-if="message.length > 0"></plan-message>
                <slot name="associated-failed"></slot>
            </div>

            <div class="refund-info" v-if="refundTip">
                <p>{{$t('switch_plan.refund_info')}}</p>
            </div>
            <div class="middle-text">
                <p v-html="$t('switch_plan.contact_us_switch', lang, {
                    link: config.support_team
                })"></p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { config } from 'CONFIG';
import planMessage from '@/components/planMessage.vue';
export default Vue.extend({
    components: {
        planMessage
    },
    props: {
        message: {
            type: Object
        },
        refundTip: Boolean
    },
    data() {

        return {
            config
        };

    },
    computed: {
        lang(): string {

            return this.$store.getters.lang;

        }
    }
});
</script>

<style lang="less" scoped>
.switchSuccess{
    max-width: 600px;
    text-align: center;
    margin: 0 auto;
}

.content-top{
    margin-bottom: 10px
}

.middle-package{
    margin-bottom: 10px;
    .package{
        margin-bottom: 10px;
    }
}
</style>
